import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../../configuration/setup/store';

export interface RentalCompany {
    accountId: string;
}

export interface AppState {
    sessionExpiredAcknowledged: boolean;
    isDeletePending: boolean;
    rentalCompanies: RentalCompany[];
}

const initialState: AppState = {
    sessionExpiredAcknowledged: false,
    isDeletePending: false,
    rentalCompanies: [],
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        hideSessionExpiredDialog: state => {
            state.sessionExpiredAcknowledged = true;
        },
        setIsDeletePending: (state, action: PayloadAction<boolean>) => {
            state.isDeletePending = action.payload;
        },
        setRentalCompanies: (state, action: PayloadAction<RentalCompany[]>) => {
            state.rentalCompanies = action.payload;
        },
    },
});

export const { hideSessionExpiredDialog, setIsDeletePending, setRentalCompanies } = appSlice.actions;

export const getSessionExpiredAcknowledged = (state: RootState) => state.app.sessionExpiredAcknowledged;
export const getIsDeletePending = (state: RootState) => state.app.isDeletePending;
export const getRentalCompanies = (state: RootState) => state.app.rentalCompanies;

export default appSlice.reducer;
